export const state = {
  filters: [],
  tiers: [],
  categories: [],
  collections: [],
  badges: [],
  details: {
    vendorData: {
      name: '',
    },
  },
};
